module.exports = "/assets/ec378245c76465aff717354c7be82f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/Y4.png
// module id = 2017
// module chunks = 0